module.exports = __webpack_public_path__ + "img/eyes2.ec92a398.png";